import { routerReducer } from "@ngrx/router-store";
import { ActionReducerMap, MetaReducer } from "@ngrx/store";
import { environment } from "environments/environment";
import { clearStateMetaReducer } from "./clear-state.metareducer";
import { loadingReducer, LoadingState } from "./loading";

export interface State {
  loading: LoadingState;
}

export const reducers: ActionReducerMap<any> = {
  router: routerReducer,
  loading: loadingReducer
};

export const metaReducers: MetaReducer<any>[] =
  !environment.production ? [clearStateMetaReducer] : [clearStateMetaReducer];
